import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  TabTextLabel,
} from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { useRef, useState } from 'react';
import { gridSizeMdLg12, handleAxiosError, useDownloadFile } from '@/shared';
import dayjs from 'dayjs';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import CustomAutocompleteFetchForm from '@/shared/components/ui/CustomAutocompleteFetchForm';
import { OLT } from '@/shared/interfaces';
import useAutocompleteFetch from '@/shared/hooks/useAutocompleteFetch';
import { getOLTs } from '@/shared/actions/erp';

export interface ConfirmRejectOTDialogProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}


let toastId:any;

const mostrarToast = () => {
  toastId = toast.loading("Descargando reporte...", {
    closeOnClick: false,
    draggable: false
  });
};

const cerrarToast = () => {
  toast.dismiss(toastId);
};


const ModalGenerarReportesOLTs: React.FC<ConfirmRejectOTDialogProps> = ({
  open,
  setOpen,
}) => {
  const [expanded, setExpanded] = useState<number | null>(1);
  const sectionRefs = useRef<(HTMLDivElement | null)[]>([]);
  
  const formOltReporte = useForm()

  const handleChange = (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    console.log(event)
    setExpanded(isExpanded ? panel : null);
  };
  const {
    fetchAutocompleteOLT
  } = useAutocompleteFetch();



  const generarReporteOLTsNaps = async() => {
    try {
      const {handleDownloadFile} = useDownloadFile()
      mostrarToast()
      await handleDownloadFile({
        url:"api/v1/reporte-olt-naps/",
        method:"post",
        data:{
          olt:formOltReporte.getValues("olt"),
        },
        nameFile:`Reporte NAPs por OLT ${formOltReporte.getValues("raw_olt")?.nombre} - ${dayjs().format("DD-MM-YYYY")}`,
        extensionFile:"xlsx"
      })
      
    } catch (error) {
      handleAxiosError(error);
    }
    cerrarToast()
    setOpen(false);
  }

  return (
    <ScrollableDialogProps
      open={open}
      title="Generar Reporte de OLTs"
      cancelTextBtn="Cerrar"
      showConfirmBtn={false}
      // actions
      onClose={() => {
        setOpen(false);
      }}
      // content
      minWidth="42%"
      contentNode={
        <>
          <Grid container item {...gridSizeMdLg12} spacing={3} justifyContent={"center"}>
            <Grid container item {...gridSizeMdLg12}>

              {/* Reporte de NAPS por OLTs */}
              <Accordion
                key={`seccion-pasos-area-${1}`}
                expanded={expanded === 1}
                onChange={handleChange(1)}
                sx={{border:2, borderColor:"whitesmoke", borderBottomColor:"gray"}}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                  sx={{backgroundColor:"whitesmoke"}}
                >
                  <TabTextLabel color="black" text={`Reporte de NAPs por OLT`} mt={0} pb={0} pl={0} pt={0} />
                </AccordionSummary>
                <AccordionDetails sx={{backgroundColor:"white", }}>
                  <Grid container item {...gridSizeMdLg12} padding={3} sx={{border:2, borderColor:"whitesmoke"}} ref={(el) => (sectionRefs.current[0] = el)} my={2}>
                      <Typography>Genera un reporte de todas las NAPs que pertenecen a una OLT</Typography>
                  </Grid>
                  <Grid container item {...gridSizeMdLg12} gap={2}>
                    <CustomAutocompleteFetchForm<OLT>
                      // disabled={!bodega_destino}
                      size={gridSizeMdLg12}
                      control={formOltReporte.control}
                      name="olt"
                      label="OLT"
                      fetchData={fetchAutocompleteOLT}
              
                      getOptionLabel={(opt) => `${opt.nombre}` || ''}
                      key={'autocomplete-olt'}
                      getOptionKey={(opt) => opt.codigo}
                      initialInputValue={formOltReporte.getValues().codigo ?? ''}
                      loadOptionByValue={async (codigo) => {
                        console.log('codigo', codigo);
                        const res = await getOLTs({
                          codigo: codigo as string
                        });
                        return res.data.data[0] ?? null
              
                      }}
                      onChangeValue={(e) => {
                        formOltReporte.reset({
                          ...formOltReporte.getValues(),
                          olt: e as string
                        })
                      }}
                      required={false}
                      onChangeRawValue={(val)=>{
                        formOltReporte.setValue("raw_olt", val)
                      }}
                    />
                    <Button variant="contained" color="primary" fullWidth
                    onClick={()=>{
                      if(!formOltReporte.watch("olt")){
                        toast.error("Debe seleccionar una OLT");
                        return;
                      }
                      generarReporteOLTsNaps()
                    }}>
                      Generar Reporte 
                    </Button>
                  </Grid>
                </AccordionDetails>
              </Accordion>
            </Grid>

          </Grid>
        </>
      }
    />
  );
};

export default ModalGenerarReportesOLTs;
